<template>
  <div class="tchat-container">
    <div v-for="(message, index) in messages" :key="index" :class="getSelfClass(message.authorId)">
      <p class="tchat-author">{{ message.author }}</p>
      <p class="tchat-text">{{ message.comment }}</p>
      <p class="tchat-date">{{ message.date }}</p>
    </div>
  </div>
</template>


<script>
  /* Format de l'objet "Message" à utiliser pour remplir le tchat :
   * -> string author = Nom de l'auteur du message
   * -> string authorId = Id de l'auteur
   * -> string date = date du message
   * -> string comment = texte du message
   *
   * idUser servira à aligner les messages à gauche
   * ou à droite selon s'il est l'expéditeur ou non 
  */
  export default {
    name: "Tchat",
    props: ["messages", "idUser"],
    data() {
      return {
        
      }
    },
    methods: {
      // Génération de la classe selon la couleur
      getSelfClass(authorId) {
        if (this.idUser == authorId) {
          return "tchat-message self";
        }
        return "tchat-message";
      },
    },
    computed: {
      
    },
  }
</script>

<style scoped>

 .tchat-message .tchat-text {
   background: #F1F1F1;
   padding: 10px;
   margin-bottom: 5px;
   width: 90%;
   border-radius: 5px;
 }

  .tchat-message > p.tchat-author {
    margin-bottom: 0;
  }

  .tchat-message.self .tchat-text {
    margin-left: 10%;
    background: #A7C13C;
    color: #FFFFFF;
  }

  .tchat-message.self .tchat-author, .tchat-message.self .tchat-date {
    text-align: right;
  }

  .tchat-date {
    font-size: 10px;
    color: #808080;
  }


</style>



// WEBPACK FOOTER //
// src/components/Tchat.vue